import { UserFromAPI } from "../../../types/auth.types";
import { Filter } from "../Filters";

export const userTechiniciansFields = ["client_owner", "theurapists_involved_in_treamtent"]
export const userM2mFields = ["assigned_users", "participant_users"]
export const userM2oFields = ["user_created", "user_updated", "done_by"]

export const DYNAMIC_USER_FIELDS = [...userTechiniciansFields, ...userM2mFields, ...userM2oFields]

const transformRelativeUserToCurrentUserValue = (field: string, filter: {}, user: UserFromAPI) => {

    const technician = user?.technician_id
    if (field === "client_owner") return technician?.[0]?.id
    if (field === "theurapists_involved_in_treamtent") return {"id":{"_in":[technician?.[0]?.id]}}
    if (field === "assigned_users") return user?.id
    if (field === "participant_users") return user?.id
    if (field === "user_created") return user?.id
    if (field === "user_updated") return user?.id
    if (field === "done_by") return user?.id
}

export const transformRelativeUser = (
    matchingModalFilter: Filter,
    filter: Record<string, any>,
    user: UserFromAPI
) => {
    const fieldName = matchingModalFilter.field.field;
    const value = transformRelativeUserToCurrentUserValue(fieldName, filter, user);
    const filterField = filter[fieldName] as Record<string, any>;
    const operator = Object.keys(filterField)[0]
    const completeFilter = { [matchingModalFilter.field.field]: { [operator]: value } };
    return completeFilter
}

export const isDynamicUserFilter = (value: {} | Array<any>) => {
    if (
        typeof value === "object" &&
        "isDynamic" in value &&
        value.isDynamic === true
    ) {
        return true
    }

    if (
        Array.isArray(value) &&
        value.length > 0 &&
        value.some(val => val?.isDynamic === true)
    ) {
        return true;
    }
    return false
}